@if (isReady()) {
  <page-grid [gridConfig]="gridConfig()" />
}
